import React from 'react';
import {
    Col,
    Card,
    Tooltip
  } from 'antd';
import '../../../../styles/helper.scss'
import PanoramaThumbnailViewer from '../PanoramaThumbnailViewer'
import { SPACE_THUMBNAIL_URI, THUMBNAIL_URI } from '../../../../environments/env';
import { SCENE_BASE_URL } from '../../../../environments/env';
import { Link } from 'react-router-dom';
import * as Utilities from '../../Utilities'
import ENVIRONMENT from '../../../../environments';

const sceneBaseURL = SCENE_BASE_URL;

const ReviewCardsLinkList = (props) => {
    let itemList = [];
    let searchedItems = []
    if (props.searchValue == '') {
        searchedItems = props.products
    }
    else {
        searchedItems = Utilities.getRelevanceBasedOrderedSearchResult(props.searchValue, props.products)
    }

    searchedItems.map((ele, index) => {
        let entityEntry = null
        if(ele.type === 'Product'){
            entityEntry = <ProductItemLink ele={ele} key={index} getProductReviewLink={props.getProductReviewLink}></ProductItemLink>
        }
        if(ele.type == 'Room'){
            entityEntry = <RoomItemLink ele={ele} key={index} getRoomReviewLink={props.getRoomReviewLink}></RoomItemLink>
        }
        if (entityEntry != null){
            itemList.push(entityEntry)
        }
    })

    if(props.searchValue != ''){
        props.setSearchedReviewCount(itemList.length)
    }
    if(!props.expanded){
        itemList = itemList.slice(0, 4);
    }
    return (<>{itemList}</>);
}

const ProductItemLink = (props) => {
    const { ele } = props;

    const onMouseOut = () => {
        let element = document.getElementById('error-text-'+ele.id);
        if (element) {
            element.style.display = "none";
        }
    }

    const onMouseOver = () => {
        let element = document.getElementById('error-text-'+ele.id);
        if (element) {
            element.style.display = "block";
        }
    }

    return (
        <Col lg={6} sm={24} md={8} key={props.key} offset={0}>
            <Link to={props.getProductReviewLink(ele)}>
                <Card  onMouseOver={onMouseOver} onMouseOut={onMouseOut} id="#entity-container" className="card-shadow-product" bordered={false} style={{ marginRight: "16px", marginBottom: "16px", cursor: "pointer"}}>
                    <div className="suggested-product" >
                        
                        <div className="box">
                            <img style={{objectFit: "contain",height:"280px"}} className="product-image" src={ele.thumbnail ? (ENVIRONMENT.getBaseURL(ele.platform) + THUMBNAIL_URI + ele.thumbnail) : require("../../../../assets/images/product_incomplete.svg")} />
                            <div className="home-entity-label justify-in-start" style={{zIndex:"1"}}>
                                <span className="entity-label-bg manrope f-12 w-700 blue">
                                    {ele.is_configurable == "true" ? "Config Model" : ele.type}
                                </span>
                                {ele.model_status == "10" ?<span className='entity-label-bg' style={{marginLeft: 4, lineHeight: '10px'}}>
                                    <img src='/img/alert.svg' style={{height: 12}}/>
                                </span>: ''}
                            </div>
                           
                            <div id={`error-text-${ele.id}`} className='error-id'>
                            {ele.model_status == "10" ?
                            <div className="text error manrope f-12 w-700 white" style={{display:'block'}}>
                                <div> Insufficient Model Info</div>
                                <div className="manrope f-12 w-500 white" style={{marginTop: 4}}>Click to Review Message From Admin</div>
                            </div>
                             : ele.is_configurable == "true" ?
                             <div className="text manrope f-12 w-700 white">
                              Click to select materials for your Clay Model
                             </div> : 
                             <div className="text manrope f-12 w-700 white">
                              Click to review and approve your Product Model
                             </div>}
                             </div>
                        </div>
                        <hr style={{marginTop: 0,marginBottom: 0}}/>
                        <div className="product-name" style= {{margin:'12px',textAlign:"left"}}>
                            <div className='justify-in-start'>
                                <span className="manrope f-14 black-14 w-500 clamp-text w-50">{ele.name}</span>
                                <Tooltip title={<span className='manrope f-12 white'>{Utilities.timestampToTimeSince(ele.last_modified, 'tooltip')}</span>}>                                                  
                                    <span className="manrope f-12 grey-77 w-500 time-clock-bg"  style={{marginLeft: 4}}>
                                        <img src='/img/carbon_time.svg'  style={{marginRight: 2}}/>{Utilities.timestampToTimeSince(ele.last_modified)}
                                    </span>
                                </Tooltip>
                            </div>
                            <div className="manrope f-12 grey-77 capitalize justify-in-start" style= {{marginBottom:0, marginTop: 8,textAlign:"left"}}> 
                                <span  style={{marginRight: 4}}>Category: </span>

                                <span style={{"color":"#333333"}}>{ele.category}</span>
                            </div>
                            
                        </div>                                    
                    </div>
                </Card>
            </Link>
        </Col>
    )
}

const RoomItemLink = (props) => {
    const { ele } = props
    const onMouseOut = () => {
        let element = document.getElementById('error-room-text-'+ele.id);
        if (element) {
            element.style.display = "none";
        }
    }

    const onMouseOver = () => {
        let element = document.getElementById('error-room-text-'+ele.id);
        if (element) {
            element.style.display = "block";
        }
    }
    return (
        <Col lg={6} sm={24} md={8} key={props.key} offset={0}>
            <Link to={props.getRoomReviewLink(ele.id)}>
            
                    <Card  onMouseOver={onMouseOver} onMouseOut={onMouseOut} id="#entity-container" className="card-shadow-product" bordered={false} style={{ marginRight: "16px", marginBottom: "16px"}}>
                            <div className="suggested-product" >
                                <div className="box">
                                    <img style={{objectFit: "contain",height:"280px"}} className="product-image" src={ele.thumbnail ? (ENVIRONMENT.getBaseURL(ele.platform) + SPACE_THUMBNAIL_URI + ele.id + '/' + ele.thumbnail) : require("../../../../assets/images/space_incomplete.svg")} />
                                    <div className="home-entity-label justify-in-start" style={{zIndex:"1"}}>
                                        <span className="entity-label-bg manrope f-12 w-700 blue">
                                            Space
                                        </span>
                                        {ele.model_status == "10" ?<span className='entity-label-bg' style={{marginLeft: 4, lineHeight: 10}}>
                                            <img src='/img/alert.svg' style={{height: 12}}/>
                                        </span>: ''}
                                    </div>
                                
                                    <div id={`error-room-text-${ele.id}`} className='error-id'>
                                        {ele.model_status == "10" ?
                                            <div className="text error manrope f-12 w-700 white" style={{display:'block'}}>
                                                <div> Insufficient Info</div>
                                                <div className="manrope f-12 w-500 white" style={{marginTop: 4}}>Click to Review Message From Admin</div>
                                            </div>
                                            :
                                            <div className="text manrope f-12 w-700 white">
                                                Click to review and approve your Space Model
                                            </div>}
                                    </div>
                                </div>
                                <hr style={{marginTop: 0,marginBottom: 0}}/>
                                <div className="product-name" style= {{margin:"12px",textAlign:"left"}}>
                                    <div className='justify-in-start'>
                                        <span className="manrope f-14 black-14 w-500 clamp-text w-50">{ele.name}</span>
                                        <Tooltip title={<span className='manrope f-12 white'>{Utilities.timestampToTimeSince(ele.last_modified, 'tooltip')}</span>}>                                                  
                                            <span className="manrope f-12 grey-77 w-500 time-clock-bg"  style={{marginLeft: 4}}>
                                                <img src='/img/carbon_time.svg'  style={{marginRight: 2}}/>{Utilities.timestampToTimeSince(ele.last_modified)}
                                            </span>
                                        </Tooltip>
                                    </div>

                                    <div className="manrope f-12 grey-77 capitalize justify-in-start" style= {{marginBottom:0, marginTop: 8,textAlign:"left"}}> 
                                        <span  style={{marginRight: 4}}>Category: </span>
                                        <span style={{"color":"#333333"}}>{ele.category}</span>
                                    </div>
                                    
                                </div>     
                            </div>
                    </Card>
                    
            </Link>
        </Col>
    )
}

const SceneItemLink = (props) => {
    const { ele } = props
    return (
        <Col lg={6} sm={24} md={8} key={props.key} offset={0}>
            <Link to={props.getSceneReviewLink(ele.id)}>
                <Card id="#entity-container" className="card-shadow-product" bordered={false} style={{ marginRight: "16px", marginBottom: "16px"}} data-tut="reactour__scene">
                    <div className="suggested-product" >
                        <div className='box'>
                            <PanoramaThumbnailViewer style= {{"position":"relative", borderRadius:"4px"}} threeSixtyUrl={sceneBaseURL + ele.id + '/360Camera_512.jpg' } customClass="home-panorama-thumbnail-styles" />
                            <div className="home-entity-label manrope f-12 w-700 blue" style={{zIndex:"1"}}>
                                Scene 360
                            </div>
                            <div className="text manrope f-12 w-700 white">
                                Click to review and approve your Scene 360
                            </div>
                        </div>
                        <hr style={{marginTop: 0,marginBottom: 0}}/>
                        <div className="product-name"  style={{margin: '12px',textAlign:"left"}}>
                            <div className="manrope f-14 black-14 w-600">{ele.name}
                            <span className="manrope f-12 grey-77 w-500"  style={{marginLeft: 4}}>{ele.last_modified || 'N/A'}</span>
                            </div>
                            <div className="justify-space-between manrope f-16 grey-77 capitalize"  style= {{marginTop: 12, textAlign:"left"}}> 
                                <div>Item ID:</div> 
                                <div style={{"color":"#333333"}}>{ele.brand_id != '' ? ele.brand_id : "N/A"}</div>
                            </div>
                            <div className="justify-space-between manrope f-16 grey-77 capitalize" style= {{textAlign:"left",marginTop: 8}}> 
                                <div>Last Edited:</div> 
                                <div style={{"color":"#333333"}}>{ele.last_modified || 'N/A'}</div>
                            </div>
                        </div>     
                    </div>
                </Card>
            </Link>
        </Col>
    )
}

export default ReviewCardsLinkList;
